import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Agro from "@/pages/Agro";
import { Toaster } from "@/components/ui/sonner";

function App() {
    useEffect(() => {
        // Hide Emergent preview badge (per support approval — email confirmed)
        const removeBadge = () => {
            const badge = document.getElementById("emergent-badge");
            if (badge) badge.remove();
        };
        removeBadge();
        const observer = new MutationObserver(removeBadge);
        observer.observe(document.body, { childList: true, subtree: false });
        return () => observer.disconnect();
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/agro" element={<Agro />} />
                </Routes>
            </BrowserRouter>
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "#0A2614",
                        color: "#FAF9F6",
                        border: "1px solid #1D4229",
                        fontFamily: "Outfit, sans-serif",
                    },
                }}
            />
        </div>
    );
}

export default App;
